export const ADD_FORMATION_EVENT = {
  socketName: "new-formation",
};

export const UPDATE_FORMATION_EVENT = {
  socketName: "update-formation",
};
